import React, { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import { getLanguageSection, toggleSiteLanguage } from '../../../shared/services/languageService';
import { NavLink } from 'react-router-dom';

const domain = window.location.origin;

function createInitialState() {
  return {
    homePage: Cookies.get('language') === "esp" ? domain + "/es/" : domain + "/",
    rewardsPage: Cookies.get('language') === "esp" ? domain + "/es/rewards_program.html" : domain + "/rewards_program.html",
    agentPage: "",
    agencyPage: "",
    contactusPage: Cookies.get('language') === "esp" ? domain + "/es/contactus.html" : domain + "/contactus.html",
    loginPage: "",
  };
}

function NavigationPublic() {
  const [pages, setPages] = useState(createInitialState);

  const language = getLanguageSection('navigationpublic');

  useEffect(() => {
    if (Cookies.get('iscanada') === -1) {
      setPages({
        homePage: Cookies.get('language') === "esp" ? domain + "/es/" : domain + "/",
        rewardsPage: Cookies.get('language') === "esp" ? domain + "/es/rewards_program.html" : domain + "/rewards_program.html",
        agentPage: "?iscanada=-1",
        agencyPage: "?iscanada=-1",
        contactusPage: Cookies.get('language') === "esp" ? domain + "/es/contactus.html" : domain + "/contactus.html",
        loginPage: "?iscanada=-1"
      });
    }
  }, []);

  const selectlanguage = (event) => {
    event.preventDefault();
    toggleSiteLanguage();
  };

  return (
    <header id="marivalMenu" className="mr-ui sticky top-0 z-50 border-t border-[#f5660b] bg-white shadow-sm">
      <div className="mx-auto flex min-h-[70px] w-full max-w-7xl items-center justify-between px-5 md:px-8">
        <a href={pages.homePage} className="flex items-center">
          <img src="img/logo/logo.png" alt="" className="h-10 w-auto" />
        </a>

        <nav className="hidden items-center gap-9 text-sm font-medium text-slate-700 lg:flex">
          <a href={pages.homePage} className="text-[#198fd0] transition-colors hover:text-[#0d6ea9]">
            <p className="m-0">{language.welcome}</p>
          </a>
       {/*    <a href={pages.rewardsPage} className="transition-colors hover:text-[#198fd0]">
            <p className="m-0">{language.rewards}</p>
          </a>
          */}
          <div className="group relative py-6">
            <p className="m-0 cursor-default transition-colors group-hover:text-[#198fd0]">
              {language.register} <span className="text-[10px]">▼</span>
            </p>
            <div className="invisible absolute left-0 top-full min-w-48 rounded-md border border-slate-100 bg-white py-2 opacity-0 shadow-lg transition-all group-hover:visible group-hover:opacity-100">
              <NavLink className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#198fd0]" to={"/agentregister"+pages.agentPage}>
                <p className="m-0">{language.registerAgent}</p>
              </NavLink>
              <NavLink className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#198fd0]" to={"/agencyregister"+pages.agencyPage}>
                <p className="m-0">{language.registerAgency}</p>
              </NavLink>
            </div>
          </div>
          <NavLink className="transition-colors hover:text-[#198fd0]" to={"/login"+pages.loginPage}>
            <p className="m-0">{language.login}</p>
          </NavLink>
          <a href={pages.contactusPage} className="transition-colors hover:text-[#198fd0]">
            <p className="m-0">{language.contact}</p>
          </a>
          <a href="/" className="transition-colors hover:text-[#198fd0]" onClick={selectlanguage}><p className="m-0">{language.lang}</p></a>
        </nav>

        <details className="group relative lg:hidden">
          <summary className="flex cursor-pointer list-none items-center rounded-md border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 marker:hidden">
            MENU
          </summary>
          <nav className="absolute right-0 top-12 w-64 rounded-md border border-slate-100 bg-white p-3 text-sm font-medium text-slate-700 shadow-lg">
            <a href={pages.homePage} className="block rounded px-3 py-2 text-[#198fd0] hover:bg-slate-50">
              <p className="m-0">{language.welcome}</p>
            </a>
            <a href={pages.rewardsPage} className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]">
              <p className="m-0">{language.rewards}</p>
            </a>
            <NavLink className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]" to={"/agentregister"+pages.agentPage}>
              <p className="m-0">{language.registerAgent}</p>
            </NavLink>
            <NavLink className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]" to={"/agencyregister"+pages.agencyPage}>
              <p className="m-0">{language.registerAgency}</p>
            </NavLink>
            <NavLink className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]" to={"/login"+pages.loginPage}>
              <p className="m-0">{language.login}</p>
            </NavLink>
            <a href={pages.contactusPage} className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]">
              <p className="m-0">{language.contact}</p>
            </a>
            <a href="/" className="block rounded px-3 py-2 hover:bg-slate-50 hover:text-[#198fd0]" onClick={selectlanguage}><p className="m-0">{language.lang}</p></a>
          </nav>
        </details>
      </div>
    </header>
  );
}

export default NavigationPublic;
